
import { IonButton, IonIcon, IonListHeader } from "@ionic/react";
import ExploreListItem from "components/listElements/ExploreListItem/ExploreListItem";
import { ExploreElement } from "models/ExploreElementModel/ExploreElementModel";
import { FunctionComponent, useState } from "react";
import { Trans } from "react-i18next";
import Icon from '../../../components/icons/Icon';

interface EventSectionProps {
  events: ExploreElement[];
  activeTab: number;
  openEventModal: (contest: ExploreElement) => void;
}

const EventSection: FunctionComponent<EventSectionProps> = (props: EventSectionProps) => {
  const [visibleEventsCount, setVisibleEventsCount] = useState(3);
  const { events, activeTab, openEventModal } = props;

  if (events.length === 0) {
    return null; // Return null if there are no contests to display
  }

  return (

    <div
      className="section-container"
      style={{ marginBottom: '16px' }}
    >
      {/* Contests Header */}
      <IonListHeader style={{ paddingLeft: '0', marginBottom: '8px' }}>
        {
          <Icon
            name="SingerSidedHairIcon"
            size="default"
            color="--ion-color-primary"
            marginLeft={8}
            marginRight={4}
            style={{ backgroundColor: 'transparent' }}
          />
        }
        <Trans i18nKey="EVENTS">Events</Trans>
        <span
          style={{
            marginLeft: '8px',
            fontSize: '12px',
            color: 'var(--ion-color-primary)',
          }}
        >
          ({events.length})
        </span>
      </IonListHeader>
      <div className="items-container">
        {events.slice(0, visibleEventsCount).map((item, idx) => (
          <div
            key={`${item.id}_${idx}`}
            style={{ marginBottom: '4px' }}
          >
            <ExploreListItem
              item={item}
              isFriend={activeTab === 1}
              onOpenEventModal={openEventModal}
            />
          </div>
        ))}

        {events.length > visibleEventsCount && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '0',
              paddingTop: '0',
            }}
          >
            {/* Events Load More Button */}
            <IonButton
              fill="clear"
              size="small"
              className="load-more-button events"
              onClick={() =>
                setVisibleEventsCount((prev) => prev + 3)
              }
              style={{
                '--border-color': 'transparent',
                '--color': 'var(--ion-color-warning)',
                '--background': 'transparent',
                '--background-hover': 'var(--ion-color-warning-tint)',
                '--color-hover': 'var(--ion-color-warning-contrast)',
                boxShadow: 'none',
              }}
            >
              <Icon
                name="SingerSidedHairIcon"
                size="small"
                color="--ion-color-secondary"
                marginRight={4}
                style={{ backgroundColor: 'transparent' }}
              />
              <Trans
                i18nKey="LOAD_MORE_EVENTS"
                values={{ count: events.length - visibleEventsCount }}
              >
                {events.length - visibleEventsCount} weitere Events
                anzeigen
              </Trans>
            </IonButton>
          </div>
        )}
      </div>
    </div>
  );
}
export default EventSection;
